import styled from 'styled-components'

export const Container = styled.div`
  z-index: 999999;
  position: fixed;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0px);
  padding: 2rem;
  overflow: hidden;

  button {
    transition: 0.2s;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
  }
`
